<template>
  <v-container color="secondary" class="loan-queue" grid-list-xl fluid>
    <v-card flat class="p-10" width="100%" style="height: calc(100vh - 170px)" >
      <vue-perfect-scrollbar style="height: calc(100vh - 200px);">
        <v-card color="secondary" v-for="(item, i) in relatedLoans" :key="i" class="m-b-5 m-t-5 m-r-10">
          <v-card-text>
            <v-layout row>
              <v-flex class="lg4"><h4 class="f-w-500">{{item.loanNo}}</h4></v-flex>
              <v-flex class="lg4"><h4 class="f-w-400">{{getFullName(item).fullName}}</h4></v-flex>
              <v-flex class="lg3 f-w-500">{{item.portfolioName}}</v-flex>
              <v-spacer></v-spacer>
              <v-btn
                icon
                color="primary"
                @click="installmentItems(item)"
              >
                <v-icon>mdi-format-list-bulleted</v-icon>
              </v-btn>
            </v-layout>
            <v-layout row>
              <v-flex class="lg1 p-0 p-l-10">Status</v-flex>
              <v-flex class="lg3 p-0 f-w-500">{{item.loanStatusText}}</v-flex>
              <v-flex class="lg2 p-0">Create Time</v-flex>
              <v-flex class="lg2 p-0 f-w-500">{{new Date(item.createdAt).format("yyyy-MM-dd")}}</v-flex>
              <v-flex class="lg2 p-0">Home Phone</v-flex>
              <v-flex class="lg2 p-0 f-w-500">{{tool.formatPhone(item.homePhone)}}</v-flex>
            </v-layout>
            <v-layout row>
              <v-flex class="lg1 p-0 p-l-10">SSN</v-flex>
              <v-flex class="lg3 p-0 f-w-500">{{formatSsn(item.ssn)}}</v-flex>
              <v-flex class="lg2 p-0">Bank Account #</v-flex>
              <v-flex class="lg2 p-0 f-w-500">{{formatAccountNo(item.accountNo)}}</v-flex>
              <v-flex class="lg2 p-0">Cell Phone</v-flex>
              <v-flex class="lg2 p-0 f-w-500">{{tool.formatPhone(item.cellPhone)}}</v-flex>
            </v-layout>
            <v-layout row>
              <v-flex class="lg2 p-0 p-l-10">Bank Name</v-flex>
              <v-flex class="lg6 p-0 f-w-500">{{item.bankName}}</v-flex>
              <v-flex class="lg2 p-0">Bank Routing #</v-flex>
              <v-flex class="lg2 p-0 f-w-500">{{formatAccountNo(item.routingNo)}}</v-flex>
            </v-layout>
            <v-layout row>
              <v-flex class="lg1 p-0 p-l-10">Email</v-flex>
              <v-flex class="lg5 p-0 f-w-500">{{item.email}}</v-flex>
            </v-layout>
            <v-layout row>
              <v-flex class="lg3 p-0 p-l-10">Withdrawn Reason</v-flex>
              <v-flex class="lg6 p-0 f-w-500">{{getWithdrawnReasonByCode(item.reasonCode)}}</v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </vue-perfect-scrollbar>
    </v-card>
    <v-dialog width="45%" v-model="showInstallmentItems">
      <v-card>
        <v-card-text class="secondary">
          <v-row class="p-t-10">
            <h2  class="p-t-10">PAYMENT SCHEDULE</h2>
            <v-spacer></v-spacer>
            <v-btn
              x-small
              text
              :loading="loading"
              color="blue-grey"
              class="ma-2 white--text"
              fab
              v-if="loading"
            >
              <v-icon dark>
                mdi-cloud-upload
              </v-icon>
            </v-btn>
          </v-row>
        </v-card-text>
        <v-card-actions class="p-t-5 p-r-0 p-l-0">
          <arb-simple-table
            class="section-table"
            :desserts="tableData"
            :header="layoutSetting.sectionFields"
            :height="300"
            :width="'100%'"
            :color="$vuetify.theme.themes.light.secondary"
            fontColor="#002B7F"
          ></arb-simple-table>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { DataType, Tool } from '@/util/index'
import { PaymentApi } from '@/api/pandaria'
import { LOS_DETAIL_LAYOUT_SETTING } from '@/setting/layout/pre-origination/detail'

const tool = new Tool()

export default {
  name: 'related-queue',
  props: {
    relatedLoans: Array
  },
  data () {
    return {
      input: {},
      tool: tool,
      showInstallmentItems: false,
      layoutSetting: LOS_DETAIL_LAYOUT_SETTING.PAYMENT_SCHEDULE,
      tableData: [],
      loading: false
    }
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    getWithdrawnReasonByCode (code) {
      if (code && DataType.WithdrawnReason[code]) {
        return DataType.WithdrawnReason[code]
      }
    },
    getFullName (data) {
      return {
        fullName: tool.getFullName(data)
      }
    },
    formatSsn (ssn) {
      try {
        ssn = ssn.toString().replace(/[^0-9]/gi, '')
        return '***-**' + '-' + ssn.substring(5, ssn.length)
      } catch (e) {
        return null
      }
    },
    formatAccountNo (accountNo) {
      try {
        accountNo = accountNo.toString().replace(/[^0-9]/gi, '')
        return '*****' + '-' + accountNo.substring(accountNo.length - 4, accountNo.length)
      } catch (e) {
        return null
      }
    },
    installmentItems (item) {
      const $this = this
      $this.showInstallmentItems = true
      $this.loading = true
      const request = {
        loanId: item.id
      }
      PaymentApi.getPaymentInstallmentAndActionByLoanId(request, function (result) {
        $this.tableData = result
        $this.loading = false
      })
      // ExpresswayApi.installmentItems(item, function (result) {
      //   $this.tableData = result
      //   $this.loading = false
      // })
    }
  },
  created () {
  }
}
</script>
